import { render } from "./WordHolder.vue?vue&type=template&id=235c2e50&scoped=true"
import script from "./WordHolder.vue?vue&type=script&lang=js"
export * from "./WordHolder.vue?vue&type=script&lang=js"

import "./WordHolder.vue?vue&type=style&index=0&id=235c2e50&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235c2e50"]])

export default __exports__